/**
 * State interface for avatar notification modal.
 *
 * @exports
 * @interface AvatarNotificationModalState
 */
export interface AvatarNotificationModalState {
  shouldShow: boolean;
  error: string | null;
  isModalOpen: boolean;
  reason: string | null;
  loading: {
    checkingShouldShow: boolean;
    recordingInteraction: boolean;
  };
}

/**
 * Feature key for avatar notification modal state.
 */
export const avatarNotificationModalKey = 'avatarNotificationModal';

/**
 * Initial state for avatar notification modal.
 */
export const avatarNotificationModalState: AvatarNotificationModalState = {
  shouldShow: false,
  reason: null,
  loading: {
    checkingShouldShow: false,
    recordingInteraction: false
  },
  error: null,
  isModalOpen: false
};
